module.exports = __webpack_public_path__ + "img/blocked.905247e1.svg";